import { useState } from "react";
import submit from "submit-form";
import SvgIcon from "../../../../../../parts/SvgIcon";

const MenuOptionsEditing = ({
  exercises,
  exerciseId = false,
  dayString,
  athleteId,
  shown = false,
}) => {
  const [opened, setOpened] = useState(false);
  const exerciseIndex = exercises.findIndex((ex) => ex._id === exerciseId);
  const exercise = exercises[exerciseIndex];

  return (
    <div
      className="more"
      style={{ display: shown && exerciseId ? "flex" : "none" }}
    >
      <input
        type="radio"
        name="more"
        id={`more-${exerciseId ? exerciseId : dayString}`}
      />

      <details role="list" open={opened}>
        <summary
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpened(!opened);
          }}
          onBlur={(e) => {
            if (!e.relatedTarget || !e.relatedTarget.role === "listbox") {
              e.preventDefault();
              setOpened(false);
            }
          }}
          aria-haspopup="listbox"
          className="!p-0 !h-auto"
        >
          <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
        </summary>
        <ul role="listbox" className={opened ? "opened" : ""} tabIndex="-1">
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              if (exerciseIndex >= 0) {
                submit(
                  `/actions/exercise/duplicate-from-single-day?proxyAthlete=${athleteId}`,
                  {
                    method: "POST",
                    body: exercise,
                  }
                );
              }
            }}
          >
            <a>Duplicate</a>
          </li>
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              submit("/actions/refresh?", {
                method: "GET",
                body: {
                  "modal[type]": "calendar-add-exercise",
                  day: dayString,
                  exercise: exercise._id,
                  editMode: true,
                },
              });
            }}
          >
            <a>Edit</a>
          </li>
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              submit("/actions/refresh?", {
                method: "GET",
                body: {
                  "modal[type]": "swap-exercise",
                  exercise: exercise._id,
                  editMode: true,
                },
              });
            }}
          >
            <a>Swap</a>
          </li>
          <li
            onClick={(e) => {
              e.stopPropagation();
              setOpened(false);
              submit(`/actions/exercise/remove/${exercise._id}`, {
                method: "GET",
                body: {
                  proxyAthlete: athleteId,
                },
              });
            }}
          >
            <a>Delete</a>
          </li>
        </ul>
      </details>
    </div>
  );
};

export default MenuOptionsEditing;
